export const menuItems = 
[
    {   
        id: 0,
        name : 'Navigation',
        hideForRole:'',
        disabled: true,
        type: 'label'   
    },
    {
        id: 1,
        name : 'Orders',
        url: '/',
        icon : 'feather icon-shopping-cart',
        disabled: false,
        hideForRole:'',
        type: 'link' 
    }, 
    {
        id: 2,
        name : 'Returns',
        url: '/returns',
        icon : 'feather icon-rotate-ccw',
        disabled: false,
        hideForRole:'',
        type: 'link'  
    }, 
    {
        id: 3,
        name : 'Products',
        url: '/products',
        icon : 'feather icon-clipboard',
        disabled: true,
        hideForRole:'',
        type: 'link'    
    },
    {
        id: 4,
        name : 'Credit Memo',
        url: '/credit-memo',
        icon : 'feather icon-file',
        disabled: true,
        hideForRole:'',
        type: 'link'    
    }, 
    {
        id: 5,
        name : 'Links',
        url: '/links',
        icon : 'feather icon-link',
        disabled: true,
        hideForRole:'',
        type: 'link'    
    },
    {   
        id: 6,
        name : 'Support', 
        disabled: true,
        hideForRole:'',
        type: 'label'   
    },
    {   
        id: 7,
        name : 'Need support ?',
        url: '/support',
        icon : 'feather icon-help-circle',
        disabled: true,
        hideForRole:'',
        type: 'link'    
    },
]